import addressImg from "../../assets/rafiki.png";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import AddressDetail from "./AddressDetails";

const Addresses = () => {
  const accountInfo = "bisham";

  return (
    <>
      {accountInfo ? (
        <>
          <AddressDetail />
        </>
      ) : (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              color: "white",
              px: 2,
              py: 4,
            }}
          >
            <Box sx={{ mb: 3 }}>
              <img
                src={addressImg}
                alt="location"
                style={{ width: 96, height: "auto" }}
              />
            </Box>

            <Typography variant="h6" sx={{ mb: 1 }}>
              Manage your Clikkie Account Information
            </Typography>

            <Typography variant="body2" color="gray" sx={{ mb: 1 }}>
              We put the most common settings in one place, so you can manage
              your information easily.
            </Typography>

            <Typography variant="body2" color="gray" sx={{ mb: 3 }}>
              You can now access everything in one place through your Clikkie
              Account.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0066ff",
                textTransform: "none",
                px: 2,
                py: 1,
                "&:hover": {
                  backgroundColor: "#0056cc",
                },
              }}
            >
              Manage Clikkie
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Addresses;
